export default __webpack_public_path__ + "svg/CompaniesLogos/logo_ibm.svg?be2d1a17";